// 収支系画面（ダッシュボード / 運行実績×収支 / 請求・支払 / 運賃お伺い書）で月を共有する。
// 画面はハッシュ遷移のたびに作り直すので、sessionStorage に YYYY-MM を残す。
const KEY = 'veil-neb.selectedMonth'

function norm(ym) {
  const s = String(ym == null ? '' : ym).trim()
  return /^\d{4}-\d{2}/.test(s) ? s.slice(0, 7) : ''
}

export function getSelectedMonth() {
  try { return norm(sessionStorage.getItem(KEY)) } catch { return '' }
}

export function setSelectedMonth(ym) {
  const v = norm(ym)
  try {
    if (v) sessionStorage.setItem(KEY, v)
    else sessionStorage.removeItem(KEY)
  } catch { /* private mode 等 */ }
  return v
}

// 共有月をリストへ足し、あればそれを選ぶ。無ければ末尾（最新月）。
export function resolveMonth(months) {
  const list = [...new Set((months || []).map(norm).filter(Boolean))]
  const shared = getSelectedMonth()
  if (shared && !list.includes(shared)) list.push(shared)
  list.sort()
  const month = (shared && list.includes(shared)) ? shared : (list[list.length - 1] || null)
  if (month) setSelectedMonth(month)
  return { months: list, month }
}
